// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d8-4";
export var closeButton = "_d8-6";
export var dismissButton = "_d8-3";
export var editImageWithAiContainer = "_d8-8";
export var imageUploadWrapper = "_d8-7";
export var misspelledWord = "_d8-5";
export var spellCheckContainer = "_d8-2";
export var spin = "_d8-1";
export var spinning = "_d8-0";